import { Menu, X } from "lucide-react";
import { useEffect, useState } from "react";
import { BRAND } from "../../constants/site";

const PUBLIC_LINKS = ["Services", "Stylists", "Gallery", "Reviews", "Contact"];

export function NavBar({ activeSection, onNavigate, onBookNow }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    function handleScroll() {
      setScrolled(window.scrollY > 60);
    }

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className={scrolled ? "site-nav site-nav--scrolled" : "site-nav"}>
      <div className="site-nav__inner container-wide">
        <button className="brand-button" onClick={() => onNavigate("hero")}>
          {BRAND}
        </button>

        <div className="site-nav__desktop">
          {PUBLIC_LINKS.map((label) => {
            const sectionId = label.toLowerCase();
            const isActive = activeSection === sectionId;

            return (
              <button
                key={label}
                className={isActive ? "nav-link nav-link--active" : "nav-link"}
                onClick={() => onNavigate(sectionId)}
              >
                {label}
              </button>
            );
          })}

          <button className="button button--primary" onClick={onBookNow}>
            Book Now
          </button>
        </div>

        <button className="site-nav__menu" onClick={() => setMobileOpen((current) => !current)} aria-label="Toggle navigation">
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {mobileOpen ? (
        <div className="site-nav__mobile">
          {PUBLIC_LINKS.map((label) => {
            const sectionId = label.toLowerCase();
            return (
              <button
                key={label}
                className="site-nav__mobile-link"
                onClick={() => {
                  onNavigate(sectionId);
                  setMobileOpen(false);
                }}
              >
                {label}
              </button>
            );
          })}

          <button
            className="button button--primary button--block"
            onClick={() => {
              onBookNow();
              setMobileOpen(false);
            }}
          >
            Book Now
          </button>
        </div>
      ) : null}
    </nav>
  );
}
